import { buildFacetDesignOverride, overrideReadOnly } from 'Packages/FacetRest/FacetDesignOverride';
import { FDTitleText } from '@facet-wealth/design';
import { Pillars } from './pillars';

export const normalStepOverrides = buildFacetDesignOverride()
  .nameOverride('title', {
    _component: () => FDTitleText,
    _customProps: { size: 'lg' },
  }, overrideReadOnly)
  .nameOverride('pillars', {
    _component: () => Pillars,
    _formatReadOnly: () => (_, { resource, attrName }) => resource.selectedOptions(attrName, 'prompt'),
  }, overrideReadOnly)
  .done();
